import { render, staticRenderFns } from "./AwSmoothScrollbar.vue?vue&type=template&id=8fc51656&"
import script from "./AwSmoothScrollbar.vue?vue&type=script&lang=js&"
export * from "./AwSmoothScrollbar.vue?vue&type=script&lang=js&"
import style0 from "./AwSmoothScrollbar.vue?vue&type=style&index=0&id=8fc51656&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports